export {default as drag} from "./src/drag";
export {default as dragDisable, yesdrag as dragEnable} from "./src/nodrag";



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-drag/index.js
// module id = ../../../../d3-drag/index.js
// module chunks = 4